export const API_BASE_URL =
  process.env.REACT_APP_API_URL || 'https://petrofeu-api.petrofeucode.workers.dev';

/** Public marketing / vitrine (petrofeu.site), not Pages preview URLs */
export const MARKETING_SITE_URL =
  process.env.REACT_APP_MARKETING_URL || 'https://petrofeu.site';
